var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
var NumberProvider = /** @class */ (function (_super) {
    __extends(NumberProvider, _super);
    function NumberProvider() {
        return _super.call(this) || this;
    }
    /**
     * Rounds a number to a specific number of decimal places
     *
     * @param {number} num Number to be rounded
     * @param {number} decimal number of decimals from which to round (e.g. 0=3, 1=3.1, 2=3.14, etc)
     * @returns {number} Rounded number to specific decimal point value
     * @memberof NumberProvider
     */
    NumberProvider.prototype.round = function (num, decimal) {
        if (num === null || num === undefined) {
            return num;
        }
        var decimalPlace = Math.pow(10, decimal);
        return Math.round(num * decimalPlace) / decimalPlace;
    };
    /**
     * Returns a comma-delineated string version of a number
     *
     * @param {number} data Value to be converted
     * @returns {string} The comma-delineated string literal version of the input
     * @memberof NumberProvider
     */
    NumberProvider.prototype.getCommaDelineatedNumStr = function (data) {
        if (data === null || data === undefined) {
            return '';
        }
        var dataStr = "" + data;
        var reversedStr = '';
        if (data >= 1000) {
            var commaCounter = 3;
            for (var i = dataStr.length - 1; i >= 0; i--) {
                if (commaCounter == 0) {
                    reversedStr += "," + dataStr[i];
                    commaCounter = 2;
                }
                else {
                    reversedStr += "" + dataStr[i];
                    commaCounter -= 1;
                }
            }
            dataStr = '';
            for (var i = reversedStr.length - 1; i >= 0; i--) {
                dataStr += reversedStr[i];
            }
        }
        return "" + dataStr;
    };
    /**
     * Get a formatted version of the time represented in a date object
     *
     * @param date Date
     * @param clipLeadingZeros Boolean (optional) trim leading zeros for smaller time values (e.g. 00:02:16 => 02:16)
     *
     * @return string date in hh:mm:ss format
     */
    NumberProvider.prototype.getHoursMinutesSecondsFromDate = function (date, clipLeadingZeros) {
        if (clipLeadingZeros === void 0) { clipLeadingZeros = false; }
        var dateString = date.toISOString().substr(11, 8);
        if (clipLeadingZeros) {
            while (dateString.charAt(0) == '0' || dateString.charAt(0) == ':') {
                var shouldBreak = dateString.charAt(0) == ':';
                dateString = dateString.substr(1);
                if (shouldBreak) {
                    break;
                }
            }
        }
        return dateString;
    };
    NumberProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], NumberProvider);
    return NumberProvider;
}(BaseProvider));
export { NumberProvider };
//# sourceMappingURL=number.js.map


// WEBPACK FOOTER //
// ./src/providers/number.ts.pre-build-optimizer.js